import TextArea from "@/Atoms/Input/TextArea";
import styles from './InteractionModal.module.scss'
import TextInput from "@/Atoms/Input/TextInput";
import {useForm} from "@inertiajs/react";
import React, {FormEventHandler, useEffect, useRef, useState} from "react";
import Button from "@/Atoms/Input/Button";
import InputError from "@/Components/InputError";
import Image from "@/Atoms/Image/Image";
import Modal from "@/Organisms/Modals/Modal";
import {Tab, TabPanel, Tabs} from "@/Molecules/Tabs/Tabs";
import Checkbox from "@/Components/Checkbox";
import defaultImageSet from "@images/defaults/interaction/defaultImageSet";
import FileInput from "@/Atoms/Input/FileInput";
import Info from "@/Molecules/Info/Info";


type InteractionModalProps = {
  isPlatformHack: boolean
  privateOnly?: boolean
  publicOnly?: boolean
  onSubmit?: (input: any) => void
  onCancel?: () => void
  action?: ActionType,
  isObituary?: boolean,
  isLoading?: boolean,
  inputErrors: any,
  defaultValues?: {
    text?: string,
    firstname?: string,
    lastname?: string,
    email?: string,
  }
}
export enum ActionType {
  None = 'none',
  Condolence = 'condolence',
  CondolenceReply = 'reply',
  Flower = 'flower',
  Candle = 'candle'
}
export default function InteractionModal(
  {
    isPlatformHack,
    onSubmit,
    privateOnly,
    publicOnly,
    onCancel,
    action,
    isLoading,
    isObituary,
    defaultValues,
    inputErrors
  }: InteractionModalProps) {

  type Image = {
    url: string|File,
    fileName: string,
    type: string,
    id?: number,
  }

  type Form = {
    text: string,
    is_private?: boolean,
    action: string,
    name?: string,
    email?: string,
    youtube_url?: string,

    files?: Image[]
  }
  const dummyImage = {
    url: defaultImageSet[0].url,
    fileName: 'Dummy photo',
    id: 1,
    type: 'default'
  }


  const {data, setData, processing, errors, setError, clearErrors, reset} = useForm<Form>({
    text: '',
    is_private: false,
    action: '',
    name: '',
    email: '',
    youtube_url: '',
    files: [],
    // file: '',
  });

  const [showLibrary, setLibrary] = useState(false)

  const handleSubmit: FormEventHandler = (e) => {
    e.preventDefault();
    clearErrors();
    onSubmit && onSubmit(data)
  };


  const handleSelectDefault = (index: number) => {

    const defaultImage = defaultImageSet[index]
    if (!defaultImage) {
      return;
    }
    addPhoto(defaultImage.url, 'Foto uit bibliotheek', 'default', index)
    setLibrary(false)
  }


  useEffect(() => {
    const isOpen = action !== ActionType.None;

    if (isOpen && defaultValues) {
      let dataCpy = {text: data.text, action: data.action}//{...data}
      dataCpy = {...dataCpy, ...defaultValues, action: action?.toString() || 'none'};
      setData(dataCpy)
    }
    if (!isOpen) {

      clearErrors();
    }
  }, [action]);

  useEffect(() => {
    setError(inputErrors)
  }, [inputErrors]);


  const changeActionByTab = (tab: number) => {
    switch (tab) {
      case 0:
        setData('action', ActionType.Condolence);
        break;
      case 1:
        setData('action', ActionType.Candle);
        break;
      case 2:
        setData('action', ActionType.Flower);
        break;
    }
  }

  if (action === ActionType.None) {
    return <></>
  }
  // map action to type
  let currentTab = 0;
  switch (data.action) {
    case ActionType.Condolence:
    case ActionType.CondolenceReply:
      currentTab = 0;
      break;
    case ActionType.Candle:
      currentTab = 1;
      break;
    case ActionType.Flower:
      currentTab = 2;
      break;
  }

  const addPhoto = (url: string, fileName: string, type: string, id: number) => {
    const newFiles = data.files ? [...data.files] : [];
    newFiles.push({url, fileName, type, id})
    setData('files', newFiles)
  }

  const removePhoto = (index: number) => {
    const newFiles = data.files ? [...data.files] : [];
    newFiles.splice(index, 1)
    setData('files', newFiles)
  }


  const handlePhoto = (file?: File) => {
    if (!file){
      return;
    }
    // Add file to files
    // const file = e.target.files ? e.target.files[0] : null;
    const newFiles = data.files ? [...data.files] : [];
    newFiles.push({url: file, fileName: file.name, type: 'upload'})
    setData('files', newFiles)
}


  if (showLibrary){
    return <Modal title={'Kies een foto uit onze bibliotheek'} onCancel={() => setLibrary(false)}>
      <div className={styles.thumbnails}>
        {defaultImageSet.map((img: any, index: number) => {
          return <img key={index} alt={`Foto ${index}`} src={img.url} onClick={() => handleSelectDefault(index)} />
        })}
      </div>

      <footer className={'flex'}>
        <button className={'bg-beige beigedarker'} onClick={() => setLibrary(false)}>
          Ga terug
        </button>
        <button className={'grow justify-center'}>
          Foto gebruiken
        </button>
      </footer>
    </Modal>
  }

  const title = action === ActionType.CondolenceReply ? 'Reageer op bericht' : isPlatformHack ? 'Reactie achterlaten' : 'Condoleren'
  const fileErrors = Object.entries(errors)
  .filter(([key]) => key.startsWith('files.'))
  .map(([_, value]) => value);

  const submitButtonText =
    currentTab === 0 ?
      isPlatformHack ? 'Reactie achterlaten' : 'Condoleren' :
      currentTab === 1 ? isPlatformHack ? 'Kaarsje aansteken' : 'Kaars branden' :
        'Bloem plaatsen'

  return <Modal title={title} onCancel={onCancel}>
    {action !== ActionType.CondolenceReply &&
      <Tabs className={styles.tabs}
            onChange={i => changeActionByTab(i)}
            value={currentTab}
      >
        <Tab>{isPlatformHack ? 'Reactie achterlaten' : 'Condoleren'}</Tab>
        <Tab>{isPlatformHack ? 'Kaarsje aansteken' : 'Kaars branden'}</Tab>
        <Tab>Bloem plaatsen</Tab>
      </Tabs>
    }

    <form onSubmit={handleSubmit} className={styles.form} noValidate>
      <fieldset disabled={isLoading}>
        <TabPanel value={currentTab} index={0}>
          <div>
            <label>Je bericht</label>
            <TextArea
              value={data.text || ''}
              onChange={(e) => setData('text', e.target.value)}
            />

            <InputError message={errors.text}/>
          </div>

          {!publicOnly && <div className="form__item checkbox">
              <Checkbox
                  name="is_private"
                  id="is_private"
                  className={styles.checkbox}
                  disabled={privateOnly}
                  checked={privateOnly || data.is_private || false}
                  onChange={(e) => setData('is_private', e.target.checked)}
              />
              <label htmlFor="is_private">Condoleance alleen zichtbaar maken voor nabestaanden</label>
              <InputError message={errors.is_private}/>
          </div>}


        </TabPanel>


        <div>
          <label>Je naam</label>
          <TextInput
            value={data.name || ''}
            onChange={(e) => setData('name', e.target.value)}
          />
          <InputError message={errors.name}/>
        </div>
        <div className={'my-2'}>
          <label>
            Je e-mailadres&nbsp;
            <Info>Je e-mailadres wordt niet getoond op de pagina en niet ingezet voor commerciële doeleinden. We
              gebruiken het e-mailadres alleen als dat noodzakelijk is, bijvoorbeeld bij een probleem.</Info>
          </label>
          <TextInput
            value={data.email || ''}
            type={'email'}
            onChange={(e) => setData('email', e.target.value)}
          />
          <InputError message={errors.email}/>
        </div>
        <TabPanel value={currentTab} index={0}>
          <div className={'my-2'}>
            <label>YouTube URL</label>
            <TextInput
              value={data.youtube_url || ''}
              onChange={(e) => setData('youtube_url', e.target.value)}
              placeholder={'https://www.youtube.com/watch?v=abc123'}
            />
            <InputError message={errors.youtube_url}/>
          </div>
          <div className={'my-2'}>
            <FileInput
              onChange={handlePhoto} label={'Klik hier om foto\'s toe te voegen'}
              className={styles.uploadButton}
              showName={false}
            />

            {fileErrors.length > 0 && (
              <div className="text-red-600 text-sm mt-2">
                {fileErrors.map((msg, i) => (
                  <div key={i}>{msg}</div>
                ))}
              </div>
            )}
            <div className={styles.images}>
              {data.files?.map((image: Image, index) => {
                return <div key={index}>
                  <Image src={image.url} alt={''} className={styles.image}/>
                  <div className={styles.fileName}>{image.fileName}</div>
                  <div className={styles.bin} onClick={() => removePhoto(index)}>
                    <i className="fa-regular fa-trash-can"></i>
                  </div>
                </div>
              })}
            </div>

            <label>Geen eigen foto?
              <a href={'#'} onClick={(e) => {e.preventDefault(); setLibrary(true);}}> <strong>Kies</strong> </a>
              een foto uit onze bibliotheek</label>
          </div>
          {}
        </TabPanel>
        <footer>
          <button type={"submit"}>
            {isLoading && <i className="fa-solid fa-spinner fa-spin me-3"></i>}
            {submitButtonText}
          </button>
        </footer>
      </fieldset>
    </form>
  </Modal>


}
